import styled from 'styled-components';
import { withRouter } from 'react-router';
import { useHistory } from 'react-router-dom';
import PushNotificationsTable from './components/PushNotificationsTable';
import { HealtheraButton } from '../../../healtheraComponents';

function PushNotificationsPage() {
  const history = useHistory();

  return (
    <>
      <TitleContainer>
        <Title>Push Notifications</Title>
        <ButtonContainer>
          <HealtheraButton
            onClick={() => history.push('campaigns/create')}>
            Add New
          </HealtheraButton>
        </ButtonContainer>
      </TitleContainer>

      <PushNotificationsContainer>
        <PushNotificationsTable />
      </PushNotificationsContainer>
    </>
  );
}

export default withRouter(PushNotificationsPage);

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 25px 0;
`;

const Title = styled.div`
  font-size: 23px;
  font-weight: bold;
`;

const ButtonContainer = styled.div`
  margin-left: 16px;
`;

const PushNotificationsContainer = styled.div`
  margin: 16px 0;
  background-color: #FFFFFF;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.25);
  padding: 2rem;
`;
